module.exports = {
  "calendar": "\u05DC\u05D5\u05D7 \u05E9\u05E0\u05D4",
  "day": "\u05D9\u05D5\u05DD",
  "dayPeriod": "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6/\u05D0\u05D7\u05D4\u05F4\u05E6",
  "endDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E1\u05D9\u05D5\u05DD",
  "era": "\u05EA\u05E7\u05D5\u05E4\u05D4",
  "hour": "\u05E9\u05E2\u05D4",
  "minute": "\u05D3\u05E7\u05D4",
  "month": "\u05D7\u05D5\u05D3\u05E9",
  "second": "\u05E9\u05E0\u05D9\u05D9\u05D4",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.startDate, " \u05E2\u05D3 ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "\u05D6\u05DE\u05DF \u05E0\u05D1\u05D7\u05E8: ".concat(args.time);
  },
  "startDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05EA\u05D7\u05DC\u05D4",
  "timeZoneName": "\u05D0\u05D6\u05D5\u05E8 \u05D6\u05DE\u05DF",
  "weekday": "\u05D9\u05D5\u05DD \u05D1\u05E9\u05D1\u05D5\u05E2",
  "year": "\u05E9\u05E0\u05D4"
};